export default function EventSpecsSkeleton(): React.ReactNode {
  return (
    <div className='rounded-2xl border border-gray-200 p-4'>
      <div className='flex animate-pulse space-x-4'>
        <div className='flex-1 space-y-4 py-1'>
          <div className='h-4 rounded bg-gray-200'></div>
          <div className='h-4 w-1/2 rounded bg-gray-200'></div>
          <hr />
          <div className='grid grid-cols-2 gap-x-4 gap-y-4'>
            <div className='h-12 rounded bg-gray-200'></div>
            <div className='h-12 rounded bg-gray-200'></div>
            <div className='h-12 rounded bg-gray-200'></div>
            <div className='h-12 rounded bg-gray-200'></div>
            <div className='h-12 rounded bg-gray-200'></div>
            <div className='h-12 rounded bg-gray-200'></div>
          </div>
          <div className='space-y-2'>
            <div className='h-4 rounded bg-gray-200'></div>
            <div className='h-4 rounded bg-gray-200'></div>
            <hr className='my-3' />
            <div className='h-16 rounded bg-gray-200'></div>
          </div>
        </div>
      </div>
    </div>
  );
}
